import a from "./roundTo4Dp";
export default (function (c, d, e) {
  c /= 255, d /= 255, e /= 255;
  var f = Math.max(c, d, e),
      i = Math.min(c, d, e),
      j = 0,
      k = 0,
      m = (f + i) / 2,
      l = f - i;
  return l && (k = .5 < m ? l / (2 - f - i) : l / (f + i), f === c ? j = (d - e) / l + (d < e ? 6 : 0) : f === d ? j = (e - c) / l + 2 : f === e ? j = (c - d) / l + 4 : void 0, j /= 6), [j, k, m].map(a);
});